import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import { useApolloClient } from '~/lazy_apollo/client';
import { useEatDestroySessionMutation } from '~/libs/gql/mutations/eat/eatDestroySessionMutation.generated';

export const useSignOut = () => {
  const intl = useIntl();
  const client = useApolloClient();
  const { enqueueSnackbar } = useSnackbar();
  const [destroySession] = useEatDestroySessionMutation();

  return useCallback(async () => {
    try {
      await destroySession();
    } catch {
      enqueueSnackbar(intl.formatMessage({ defaultMessage: "We couldn't sign you out. Please try again." }), { variant: 'error' });
      return;
    }

    enqueueSnackbar(intl.formatMessage({ defaultMessage: 'Signed out' }), { variant: 'success' });
    // Drops everything cached for the signed-in user and refetches the visible queries signed out.
    // The session is already gone, so a refetch that fails (or is interrupted by the reset) isn't a failed sign-out.
    await client?.resetStore().catch((error: unknown) => {
      console.error('[useSignOut] Refetching after sign out failed', error);
    });
  }, [client, destroySession, enqueueSnackbar, intl]);
};
